interface PitchLinesBackgroundProps {
  variant?: 'centerCircle' | 'penaltyBox' | 'halfwayLine';
  className?: string;
}

const PitchLinesBackground = ({ variant = 'centerCircle', className = '' }: PitchLinesBackgroundProps) => {
  return (
    <svg 
      className={`absolute inset-0 w-full h-full pointer-events-none ${className}`}
      style={{ opacity: 0.08 }}
      viewBox="0 0 400 400"
      preserveAspectRatio="xMidYMid slice"
    >
      {variant === 'centerCircle' && (
        <>
          {/* Center circle */}
          <circle 
            cx="200" 
            cy="200" 
            r="80" 
            stroke="hsl(var(--pitch-line))" 
            strokeWidth="2" 
            fill="none" 
          />
          {/* Center dot */}
          <circle 
            cx="200" 
            cy="200" 
            r="4" 
            fill="hsl(var(--pitch-line))" 
          />
          {/* Halfway line */}
          <line 
            x1="0" 
            y1="200" 
            x2="400" 
            y2="200" 
            stroke="hsl(var(--pitch-line))" 
            strokeWidth="2" 
          />
        </>
      )}
      
      {variant === 'penaltyBox' && (
        <>
          {/* Penalty box corner arc */}
          <path 
            d="M 100 100 Q 100 50, 150 50" 
            stroke="hsl(var(--pitch-line))" 
            strokeWidth="2" 
            fill="none" 
          />
          <path 
            d="M 300 100 Q 300 50, 250 50" 
            stroke="hsl(var(--pitch-line))" 
            strokeWidth="2" 
            fill="none" 
          />
          {/* Penalty arc */}
          <path 
            d="M 150 200 Q 200 240, 250 200" 
            stroke="hsl(var(--pitch-line))" 
            strokeWidth="2" 
            fill="none" 
          />
        </>
      )}
      
      {variant === 'halfwayLine' && (
        <>
          {/* Halfway line with small details */}
          <line 
            x1="200" 
            y1="0" 
            x2="200" 
            y2="400" 
            stroke="hsl(var(--pitch-line))" 
            strokeWidth="2" 
          />
          {/* Center circle partial */}
          <circle 
            cx="200" 
            cy="200" 
            r="60" 
            stroke="hsl(var(--pitch-line))" 
            strokeWidth="2" 
            fill="none" 
            strokeDasharray="10 10"
          />
        </>
      )}
    </svg>
  );
};

export default PitchLinesBackground;
